import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import speciesUrl from '../utils/speciesUrl';

// What champis-species' own speciesReferenceLinks() returns.

function getSpeciesReferenceLinks() {
  return window.flarum.reg.get('champis-species', 'forum/components/SpeciesInfoBoxes')?.speciesReferenceLinks;
}
/**
 * Where to check the species chosen in a card's or a finding's window, on one
 * line under it: its champis.net page, then the links of that page's own
 * "Référentiels" box. In new tabs, not to lose the form being filled in.
 *
 * Those links can take a few seconds (IUCN): the window doesn't wait for them,
 * and just goes without if that fails.
 */
export default class SpeciesReferences extends Component {
  loadedGbifId = null;
  links = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (this.attrs.gbifId !== this.loadedGbifId) this.load();
  }
  view() {
    const {
      gbifId,
      name
    } = this.attrs;
    return m("div", {
      className: "ChampisSpeciesReferences"
    }, m("span", null, app.translator.trans('champis-species.forum.species_page.references')), m("a", {
      href: speciesUrl(gbifId, name),
      target: "_blank",
      rel: "noopener noreferrer",
      title: name || undefined
    }, "Champis.net"), this.links ? this.links.map(link => m("a", {
      href: link.url,
      target: "_blank",
      rel: "noopener noreferrer",
      title: link.label || undefined
    }, link.name)) : m(LoadingIndicator, {
      display: "inline",
      size: "small"
    }));
  }
  load() {
    const gbifId = this.attrs.gbifId;
    this.loadedGbifId = gbifId;
    this.links = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/species/' + gbifId,
      params: {
        includeReferences: 'true'
      },
      errorHandler: () => {}
    }).then(response => {
      // Stale response for a species the user has since changed.
      if (gbifId !== this.loadedGbifId) return;
      const links = getSpeciesReferenceLinks();
      this.links = links ? links({
        id: Number(response.data.id),
        ...response.data.attributes
      }) : [];
      m.redraw();
    }).catch(() => {
      if (gbifId !== this.loadedGbifId) return;
      this.links = [];
      m.redraw();
    });
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/SpeciesReferences', SpeciesReferences);